import React from "react"
import "./userProfileContent.scss"
import UserProfileInfo from "../userProfileInfo/userProfileInfo"
import UserProfilePosts from "../userProfilePosts/userProfilePosts"
import UserProfileKnowCred from "../userProfileKnowcred/userProfileKnowCred"
import BoxedList from "../../../../../components/ui/boxedList"
import * as routes from "../../../../../library/constants/routes"
import { generatePath } from "react-router-dom"
import ErrorBoundary from "../../../../../components/v2/ErrorBoundary"

const UserProfileContent = (props) => {
  const { userInfo, type } = props

  // const linkToProducts =
  //   type === "my-profile"
  //     ? routes.MARKETPLACE_MY_PRODUCTS
  //     : generatePath(routes.USER_PRODUCTS, { userId: userInfo.id })

  return (
    <div className="common-page__content">
      <main className="common-page__main">
        <ErrorBoundary>
          <UserProfileInfo type={type} />
        </ErrorBoundary>
        <UserProfileKnowCred userInfo={userInfo} type={type} />
        <UserProfilePosts userInfo={userInfo} {...props} />
      </main>
      <aside className="common-page__sidebar">
        {userInfo.friends_number > 0 && (
          <BoxedList
            title="Friends"
            counter={userInfo.friends_number}
            list={userInfo.friends}
            entity="users"
            linkShowAll={generatePath(routes.FRIENDS, { userId: userInfo.id })}
          />
        )}
        {/*{userInfo.products_number > 0 && (*/}
        {/*  <BoxedList*/}
        {/*    title="Products"*/}
        {/*    counter={userInfo.products_number}*/}
        {/*    list={userInfo.products}*/}
        {/*    entity="products"*/}
        {/*    linkShowAll={linkToProducts}*/}
        {/*  />*/}
        {/*)}*/}
      </aside>
    </div>
  )
}

export default UserProfileContent
